module.exports = "/_next/static/images/img2@2x-50bff75eb5a89f31349e3813f88b3436.png";